import React from 'react';
import CustomLink from 'components/TableLink';
import styles from './index.module.scss';
import CopyToClipBoard from 'components/CopyToClipBoard';

const DynamicLink =({ link='' })=>{
  return (
    <div className= {styles['container']}>
      <div className={styles['label']}>{'Dynamic Link URL'}</div>
      <div className={`d-flex ${styles['link']}`}>
        <CustomLink
          text={link}
          linkTo={link}
        />
        {link && <CopyToClipBoard copyText={link} />}
      </div>
    </div>
  );
};

export default DynamicLink;